<template>
  <div class="checkAmountBox">
    <img class="ceyiceOneImg" src="@/assets/images/ceyiceOne.png" alt="" />
    <img
      class="returnHome"
      src="@/assets/images/returnHome.png"
      alt=""
      @click="entry"
    />
    <div class="entry">
      <div class="freeEvaluation" @click="freeEvaluation">免费评估</div>
      <!--<div class="theEntrance freeEvaluations apply">申请贷款</div>-->
    </div>
    <calculated-one
      ref="CalculatedOneRef"
      :demandName="demandName"
      :demandMoney="demandMoney"
    ></calculated-one>
    <calculated-two ref="CalculatedTwoRef"></calculated-two>
  </div>
</template>
<script>
import { addressIphone, solveIosWeixin } from '@/utils';
import { Toast } from 'vant';
import bus from './utils/bus';

import CalculatedTwo from './components/CalculatedTwo.vue';
import CalculatedOne from './components/CalculatedOne.vue';

export default {
  name: 'checkAmount',
  data() {
    return {
      demandName: '',
      demandMoney: '',
    };
  },
  components: {
    CalculatedTwo,
    CalculatedOne,
  },
  mounted() {
    // 解决ios缓存
    addressIphone();

    // 键盘收起页面布局异常
    solveIosWeixin();
    bus.$on('CalculatedOneEmit', (data) => {
      this.demandName = data.demandName;
      this.demandMoney = data.demandMoney;
      // this.calCulatedOneShow = false
      bus.$emit('freeEvaluations', false);
      bus.$emit('changeCalculatedTwoShow', true);
    });
    bus.$on('calculateTwoGetData', (data) => {
      console.log('calculateTwoGetData===', data);
      const params = {
        corpName: this.demandName,
        amount: this.demandMoney,
        ...data,
      };
      this.getData(params);
    });
  },
  methods: {
    freeEvaluation() {
      console.log('23446457');
      bus.$emit('freeEvaluations', true);
    },
    getData(params) {
      this.$api.CheckAmount.insertLoanTestInfo(params).then((res) => {
        if (res.success) {
          const num = Math.round(Math.random() * 10 + 10);
          let loanableLines;
          if (params.amount < 10) {
            loanableLines = 2;
          } else {
            loanableLines = params.amount * (num / 100);
          }
          if (loanableLines >= 2000) {
            loanableLines = 2000;
          }
          bus.$emit('changeCalculatedTwoShow', false);
          this.$router.push({
            path: '/supermarket/v2/loanAmount',
            query: {
              loanableLines,
            },
          });
        } else {
          Toast({
            message: res.returnMessage,
            forbidClick: true, // 背景不可点击
          });
        }
      });
    },
    entry() {
      this.$router.push('/supermarket/v2/');
    },
  },
};
</script>
<style scoped>
.freeEvaluation {
  width: 299px;
  height: 37px;
  background: #ff6800;
  border-radius: 36px;
  border-radius: 36px;
  text-align: center;
  line-height: 37px;
  color: #ffffff;
}
.freeEvaluations {
  width: 299px;
  height: 32px;
  background: #ff6800;
  border-radius: 36px;
  border-radius: 36px;
  text-align: center;
  line-height: 32px;
  color: #ffffff;
}
.theEntrance {
  background: #fff;
  border: 1px solid #ff6800;
  box-shadow: none;
  margin-top: 8px;
  color: #ff6800;
}
.entry {
  position: absolute;
  top: 57%;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 999;
  align-items: center;
  height: 100px;
  flex-direction: column;
}
.footer {
  width: 100%;
  height: 350px;
  background: #fff;
  position: absolute;
  bottom: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: none;
}
.theNextStep {
  width: 100%;
  height: 350px;
  background: #fff;
  position: absolute;
  bottom: 0;
  display: none;
  z-index: 3;
}
.footerHeader {
  display: flex;
  width: 100%;
  height: 150px;
  background: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.masks {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: none;
}

.weui-label {
  display: block;
  width: 80px;
  word-wrap: break-word;
  word-break: break-all;
}
.bottom {
  width: 345px;
  height: 45px;
  background: #ff6800;
  border-radius: 8px;
  border-radius: 8px;
  color: #ffffff;
  line-height: 45px;
  text-align: center;
  font-size: 17px;
  font-family: PingFangSC-Semibold;
  margin-top: 40px;
}
.immediatelyCheck {
  width: 345px;
  height: 45px;
  background: #ff6800;
  border-radius: 8px;
  border-radius: 8px;
  color: #ffffff;
  line-height: 45px;
  text-align: center;
  font-size: 17px;
  font-family: PingFangSC-Semibold;
  margin-top: 40px;
}
.weui-cell {
  border-bottom: 1px solid #f7f5f1;
  margin: 0 10px;
}
.weui-label {
  color: #858585;
}
.getcode {
  color: #ff6601;
}
.returnHome {
  width: 75px;
  height: 75px;
  position: fixed;
  bottom: 5%;
  right: 20px;
}
.gray {
  color: #eeeeee;
}
.ceyiceOneImg {
  width: 100%;
}
</style>
